import React, { useState } from 'react'
import "./InfluencerAcknowledge.scss";
import InfluencerFeesModal from './InfluencerFeesModal/InfluencerFeesModal';

const InfluencerAcknowledge = () => {
    const [show, setShow] = useState(false);
    return (
        <div className='influencer_aknowledge_page'>
            <h2>Invite Acknowledgment  / <span>Rhapsody America - Auction 1843</span></h2>
            <div className="page_desc">
            <p>I hereby confirm that the above information will update the relevant information in Annex C of the Rights Assignment Agreement (the "Agreement"), and I hereby agree and assent to: (a) the initiation of the Auction, (b) accept the results of the Auction, and (c) pay the Fees, all according to the agreed upon guidelines within the Agreement</p>
            </div>
            <h4>Fees & Commissions</h4>
            <h3>Auction influencer fee: <span onClick={() => setShow(true)}>Based on their defined fee</span></h3>
            <InfluencerFeesModal show={show} handleClose={() => setShow(false)}/>
            <div className="desc_box">
                <label htmlFor="">Signature</label>
                <textarea name="" id=""></textarea>
            </div>
            <p className="note_txt">Note this Commission is for this Auction Only and based on success!</p>
            <button type="button" className="custom_btn">
                Submit
            </button>
        </div>
    )
}

export default InfluencerAcknowledge
